import RiskScore from './RiskScore';

export default RiskScore;
